import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function LabelIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Intersect" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M7.10119 13.0239c-0.71892 0.6494 -1.87351 0.6287 -2.73662 -0.0266 -0.62202 -0.4722 -1.24729 -0.9699 -1.81963 -1.5422 -0.57235 -0.5724 -1.07009 -1.1977 -1.54228 -1.81967 -0.655216 -0.86311 -0.675922 -2.0177 -0.026577 -2.73662C2.82491 4.85187 4.74268 2.96612 6.83654 1.13441c0.2534 -0.22168 0.56517 -0.367684 0.91167 -0.415742C9.00441 0.544443 12.1433 0.20576 12.9688 1.03123c0.8254 0.82548 0.4868 3.96436 0.3125 5.22056 -0.048 0.3465 -0.194 0.65827 -0.4157 0.91167 -1.8317 2.09386 -3.71747 4.01164 -5.76441 5.86044Z"
          strokeWidth="1"></path>
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M9.79492 5.45508c-0.8 0 -1.25 -0.45 -1.25 -1.25s0.45 -1.25 1.25 -1.25c0.79998 0 1.24998 0.45 1.24998 1.25s-0.45 1.25 -1.24998 1.25Z"
          strokeWidth="1"></path>
  </SvgIcon>
}
